var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeSection34(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 507 479.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bd{fill:none;}.be{fill:#f2f2f3;}.bf{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bd",
    width: 500,
    height: 479.55
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "be",
    d: "M495.42,463.71H4.59c-2.53,0-4.58-2.06-4.57-4.59,0-.76,.19-1.5,.55-2.17l37.01-67.44c.8-1.47,2.34-2.38,4.01-2.38H458.42c1.67,0,3.22,.91,4.02,2.38l37,67.42c1.2,2.23,.37,5.01-1.86,6.21-.67,.36-1.41,.55-2.17,.55M12.32,454.56H487.69l-31.98-58.26H44.3l-31.98,58.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "be",
    d: "M376.31,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "be",
    d: "M341.81,409.58h-15.46c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.47c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    className: "be",
    d: "M272.82,409.58h-15.48c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.48c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    className: "be",
    d: "M203.79,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "be",
    d: "M134.77,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    className: "be",
    d: "M410.82,409.58h-15.47c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.47c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    className: "be",
    d: "M307.29,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    className: "be",
    d: "M238.3,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    className: "be",
    d: "M169.29,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    className: "be",
    d: "M100.27,409.58h-15.46c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.47c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "be",
    d: "M65.77,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    className: "be",
    d: "M445.32,409.58h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    className: "be",
    d: "M376.31,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "be",
    d: "M341.81,434.69h-15.46c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.47c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "be",
    d: "M272.82,434.69h-15.48c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.48c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "be",
    d: "M203.79,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "be",
    d: "M134.77,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "be",
    d: "M410.82,434.69h-15.47c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.47c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "be",
    d: "M307.29,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "be",
    d: "M238.3,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "be",
    d: "M169.29,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a`",
    className: "be",
    d: "M100.27,434.69h-15.46c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.47c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "be",
    d: "M65.77,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "be",
    d: "M445.32,434.69h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "be",
    d: "M359.93,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "be",
    d: "M325.43,421.32h-15.46c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "be",
    d: "M256.42,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "be",
    d: "M187.41,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "be",
    d: "M118.4,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "be",
    d: "M394.44,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "be",
    d: "M290.92,421.32h-15.44c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "be",
    d: "M221.92,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "be",
    d: "M152.91,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "be",
    d: "M83.92,421.32h-15.48c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.48c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "be",
    d: "M428.94,421.32h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "be",
    d: "M359.93,447.53h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "be",
    d: "M325.43,447.53h-15.46c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "be",
    d: "M255.66,447.53h-83.7c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h83.7c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "be",
    d: "M118.4,447.53h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "be",
    d: "M394.44,447.53h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "be",
    d: "M290.92,447.53h-15.44c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "be",
    d: "M152.91,447.53h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "be",
    d: "M83.92,447.53h-15.48c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.48c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "be",
    d: "M51.14,447.53h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "be",
    d: "M428.94,447.53h-15.45c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.45c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "be",
    d: "M463.91,447.53h-15.49c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58h15.49c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "be",
    d: "M495.42,479.55H4.58c-2.53,0-4.58-2.05-4.58-4.58H0v-15.84c0-2.53,2.05-4.58,4.58-4.58H495.42c2.53,0,4.58,2.05,4.58,4.58v15.83c0,2.53-2.05,4.58-4.58,4.58M9.17,470.39H490.84v-6.68H9.17v6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b`",
    className: "be",
    d: "M415.14,301.22H84.87c-17.6-.02-31.86-14.28-31.88-31.88V31.88C53.01,14.29,67.27,.02,84.87,0H415.14c17.6,.02,31.86,14.28,31.88,31.88v237.45c-.02,17.6-14.28,31.86-31.88,31.88M84.87,9.16c-12.55,0-22.71,10.18-22.73,22.72v237.45c0,12.54,10.18,22.71,22.72,22.72H415.14c12.54-.01,22.7-10.18,22.71-22.72V31.88c0-12.54-10.17-22.71-22.71-22.72H84.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "be",
    d: "M442.43,242.54H57.58c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58H442.43c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "be",
    d: "M340.08,376.27H159.94c-2.53,0-4.58-2.04-4.59-4.57,0-2.05,1.35-3.85,3.32-4.41l37.53-10.72c9.73-2.81,16.44-11.71,16.47-21.84v-38.1c0-2.53,2.05-4.58,4.58-4.58h65.51c2.53,0,4.57,2.04,4.58,4.57h0v38.1c.03,10.13,6.74,19.03,16.48,21.84l37.52,10.72c2.43,.69,3.84,3.23,3.15,5.66-.56,1.97-2.36,3.32-4.4,3.32m-147.45-9.15h114.75l-6.08-1.73c-13.66-3.95-23.07-16.44-23.12-30.66v-33.5h-56.36v33.51c-.04,14.22-9.46,26.7-23.11,30.66l-6.09,1.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "be",
    d: "M250,318.96c-12.41-.04-22.7-9.63-23.61-22-.17-2.53,1.73-4.72,4.26-4.89,.1,0,.21-.01,.31-.01h38.08c2.52,0,4.57,2.03,4.58,4.56,0,.12,0,.23-.01,.35-.91,12.37-11.19,21.96-23.6,22m-13.23-17.74c3.26,7.31,11.83,10.59,19.14,7.33,3.26-1.46,5.88-4.07,7.33-7.33h-26.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M496.45,231.8h45.05v45.05h-45.05v-45.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M151.38,59.7l4.97-29.02h8.16c2.18,0,3.73,.14,4.65,.42,1.44,.42,2.55,1.21,3.33,2.36s1.17,2.57,1.17,4.26-.38,3.13-1.13,4.28-1.88,2.02-3.38,2.61c1.17,.4,2.11,1.11,2.82,2.14s1.06,2.23,1.06,3.6c0,1.87-.43,3.57-1.28,5.09s-1.96,2.61-3.33,3.28-3.3,1-5.81,1h-11.22v-.02Zm5.67-4.67h4.72c1.85,0,3.12-.13,3.81-.4,.69-.26,1.26-.75,1.72-1.46,.46-.7,.7-1.5,.7-2.38,0-1.04-.3-1.86-.91-2.45s-1.56-.89-2.87-.89h-5.86l-1.31,7.58Zm2.18-12.63h3.74c1.64,0,2.81-.13,3.53-.4,.71-.26,1.27-.72,1.68-1.37s.61-1.39,.61-2.22c0-.67-.15-1.24-.46-1.71-.3-.47-.69-.78-1.15-.94s-1.46-.24-2.99-.24h-3.79l-1.18,6.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M180.25,59.7h-4.88l4.96-29.02h10.58c1.95,0,3.41,.26,4.37,.77s1.74,1.34,2.35,2.49c.6,1.15,.9,2.6,.9,4.35,0,2.57-.63,4.63-1.89,6.18s-3.07,2.51-5.43,2.88c.66,.73,1.31,1.76,1.94,3.1,1.05,2.24,2.21,5.32,3.47,9.24h-5.26c-.21-.82-.92-3.04-2.12-6.67-.63-1.86-1.21-3.17-1.74-3.94-.38-.54-.78-.91-1.17-1.11-.4-.2-1.07-.3-2.01-.3h-2l-2.07,12.02h0Zm2.81-16.36h2.58c2.45,0,4.11-.15,4.98-.46,.86-.31,1.58-.88,2.16-1.71,.58-.83,.86-1.75,.86-2.75,0-1.1-.36-1.89-1.09-2.4-.42-.32-1.35-.48-2.77-.48h-5.38l-1.34,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M199.32,59.7l4.97-29.02h17.64l-.83,4.85h-12.74l-1.13,6.59h12.33l-.83,4.85h-12.33l-1.36,7.88h13.69l-.81,4.85h-18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M237.01,53.28h-9.42l-2.89,6.41h-5.03l13.48-29.02h5.42l3.86,29.02h-4.64l-.77-6.41h0Zm-.62-4.83l-1.37-11.68-5.26,11.68h6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M245.52,59.7l4.97-29.02h6.37c2.24,0,3.75,.09,4.55,.28,1.34,.33,2.51,.98,3.51,1.96,1,.98,1.79,2.28,2.38,3.91,.58,1.63,.87,3.59,.87,5.87,0,2.4-.3,4.62-.89,6.66-.59,2.04-1.43,3.82-2.5,5.34-1.08,1.52-2.19,2.63-3.34,3.33-1.15,.69-2.35,1.16-3.6,1.41-.82,.17-2.12,.26-3.92,.26h-8.4Zm5.68-4.67h2.48c1.81,0,3.08-.13,3.81-.38,.95-.32,1.85-.97,2.68-1.95s1.56-2.35,2.16-4.1c.61-1.75,.91-3.77,.91-6.07,0-1.9-.25-3.39-.75-4.47s-1.17-1.81-2-2.2c-.6-.26-1.64-.4-3.13-.4h-2.81l-3.35,19.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M151.38,111.5l4.96-29.02h16.65l-.83,4.85h-11.75l-1.2,6.97h11.5l-.83,4.85h-11.51l-2.12,12.35h-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M176.57,111.5h-4.88l4.96-29.02h10.58c1.95,0,3.41,.26,4.37,.77s1.74,1.34,2.35,2.49c.6,1.15,.9,2.6,.9,4.35,0,2.57-.63,4.63-1.89,6.18s-3.07,2.51-5.43,2.88c.66,.73,1.31,1.76,1.94,3.1,1.05,2.24,2.21,5.32,3.47,9.24h-5.26c-.21-.82-.92-3.04-2.12-6.67-.63-1.86-1.21-3.17-1.74-3.94-.38-.54-.78-.91-1.17-1.11-.4-.2-1.07-.3-2.01-.3h-2l-2.07,12.02h0Zm2.81-16.36h2.58c2.45,0,4.11-.15,4.98-.46,.86-.31,1.58-.88,2.16-1.71s.86-1.75,.86-2.75c0-1.1-.36-1.89-1.09-2.4-.42-.32-1.35-.48-2.77-.48h-5.38l-1.34,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M200.4,82.48h4.9l-2.68,15.76-.65,3.8c-.05,.37-.08,.7-.08,.99,0,1.23,.35,2.19,1.06,2.91,.71,.71,1.67,1.07,2.89,1.07,1.08,0,1.99-.24,2.74-.73,.75-.49,1.35-1.24,1.79-2.25,.44-1.01,.9-2.9,1.36-5.67l2.83-15.88h4.89l-2.82,15.84c-.55,3.24-1.13,5.62-1.75,7.15-.89,2.2-2.09,3.83-3.61,4.91-1.52,1.08-3.41,1.62-5.67,1.62-2.63,0-4.7-.79-6.21-2.39-1.51-1.59-2.27-3.76-2.27-6.5,0-.88,.23-2.67,.69-5.34l2.58-15.28h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M219.04,111.5l5.16-29.02h4.89l-5.16,29.02h-4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M239.12,111.5h-4.88l4.16-24.17h-7.15l.83-4.85h18.9l-.83,4.85h-6.87l-4.16,24.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M165.08,163.3h-4.67l-.85-24.25-3.77,24.25h-4.41l4.96-29.02h6.98l.73,20.33,8.03-20.33h7.04l-4.89,29.02h-4.47l4.62-24.07-9.31,24.07h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M178.44,163.3l5.16-29.02h4.89l-5.16,29.02h-4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M188.32,163.3l4.98-29.02h4.9l-4.16,24.17h12.15l-.83,4.85h-17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M208.63,163.3l4.96-29.02h4.89l-2.09,12.31,10.97-12.31h6.59l-10.69,11.41,7.81,17.61h-5.52l-5.86-13.81-4.62,4.93-1.5,8.88h-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M151.38,215.1l4.97-29.02h8.16c2.18,0,3.73,.14,4.65,.42,1.44,.42,2.55,1.21,3.33,2.35s1.17,2.57,1.17,4.25-.38,3.13-1.13,4.28-1.88,2.02-3.38,2.61c1.17,.4,2.11,1.11,2.82,2.14s1.06,2.23,1.06,3.61c0,1.87-.43,3.57-1.28,5.09-.85,1.52-1.96,2.61-3.33,3.28-1.37,.66-3.3,1-5.81,1h-11.23Zm5.68-4.68h4.72c1.85,0,3.12-.13,3.81-.4,.69-.26,1.26-.75,1.72-1.46,.46-.7,.7-1.5,.7-2.38,0-1.04-.3-1.86-.91-2.45s-1.56-.89-2.87-.89h-5.86l-1.31,7.58Zm2.18-12.63h3.74c1.64,0,2.81-.13,3.53-.4,.71-.26,1.27-.72,1.68-1.37,.41-.64,.61-1.38,.61-2.22,0-.67-.15-1.24-.46-1.71-.3-.47-.69-.78-1.15-.94s-1.46-.24-2.99-.24h-3.79l-1.18,6.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M175.33,215.1l4.97-29.02h17.64l-.83,4.85h-12.74l-1.13,6.59h12.33l-.83,4.85h-12.33l-1.36,7.88h13.69l-.81,4.85h-18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M197.5,215.1l4.97-29.02h17.64l-.83,4.85h-12.74l-1.13,6.59h12.33l-.83,4.85h-12.33l-1.36,7.88h13.69l-.81,4.85h-18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M224.59,215.1h-4.88l4.96-29.02h10.58c1.95,0,3.41,.26,4.37,.77,.96,.51,1.74,1.35,2.35,2.49,.6,1.15,.9,2.6,.9,4.35,0,2.57-.63,4.64-1.89,6.18s-3.07,2.51-5.43,2.88c.66,.73,1.31,1.76,1.94,3.1,1.05,2.25,2.21,5.33,3.47,9.25h-5.26c-.21-.82-.92-3.04-2.12-6.67-.63-1.86-1.21-3.17-1.74-3.94-.38-.54-.78-.91-1.17-1.11-.4-.2-1.07-.3-2.01-.3h-2l-2.07,12.02h0Zm2.81-16.37h2.58c2.45,0,4.11-.15,4.98-.46,.86-.31,1.58-.88,2.16-1.71,.58-.84,.86-1.75,.86-2.75,0-1.1-.36-1.89-1.09-2.39-.42-.32-1.35-.48-2.77-.48h-5.38l-1.34,7.79h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M322.24,21.68c-12.43,0-22.52,10.09-22.52,22.52s10.09,22.52,22.52,22.52,22.52-10.09,22.52-22.52-10.09-22.52-22.52-22.52Zm0,40.54c-9.93,0-18.02-8.09-18.02-18.02s8.09-18.02,18.02-18.02,18.02,8.09,18.02,18.02-8.09,18.02-18.02,18.02Zm10.34-27.97l-14.84,14.84-5.83-5.81-3.18,3.18,9.01,9.01,18.02-18.02-3.18-3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M322.24,73.09c-12.43,0-22.52,10.09-22.52,22.52s10.09,22.52,22.52,22.52,22.52-10.09,22.52-22.52-10.09-22.52-22.52-22.52Zm0,40.54c-9.93,0-18.02-8.09-18.02-18.02s8.09-18.02,18.02-18.02,18.02,8.09,18.02,18.02-8.09,18.02-18.02,18.02Zm10.34-27.97l-14.84,14.84-5.83-5.81-3.18,3.18,9.01,9.01,18.02-18.02-3.18-3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M322.24,122.64c-12.43,0-22.52,10.09-22.52,22.52s10.09,22.52,22.52,22.52,22.52-10.09,22.52-22.52-10.09-22.52-22.52-22.52Zm0,40.54c-9.93,0-18.02-8.09-18.02-18.02s8.09-18.02,18.02-18.02,18.02,8.09,18.02,18.02-8.09,18.02-18.02,18.02Zm10.34-27.97l-14.84,14.84-5.83-5.81-3.18,3.18,9.01,9.01,18.02-18.02-3.18-3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M322.24,174.45c-12.45,0-22.52,10.07-22.52,22.52s10.07,22.52,22.52,22.52,22.52-10.07,22.52-22.52-10.07-22.52-22.52-22.52Zm0,40.54c-9.93,0-18.02-8.09-18.02-18.02s8.09-18.02,18.02-18.02,18.02,8.09,18.02,18.02-8.09,18.02-18.02,18.02Zm8.09-29.28l-8.09,8.09-8.09-8.09-3.18,3.18,8.09,8.09-8.09,8.09,3.18,3.18,8.09-8.09,8.09,8.09,3.18-3.18-8.09-8.09,8.09-8.09-3.18-3.18Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection34);
export default __webpack_public_path__ + "static/media/home_section_3_4.d282b9d0e0daa76244b5dc92bb62daeb.svg";
export { ForwardRef as ReactComponent };